@if (thread?.author.type === "NonAnonymousAuthor") {
    <div class="position-relative avatar">
        <username-icon context="thread"
                       [userInfos]="userInfos()"></username-icon>
    </div>
} @else {
    <div class="avatar" [style.color]="thread.author.color">
        <i class="far {{thread.author.icon}}"></i>
    </div>
}

@if(!threadUpdateMode){
    <div class="media-body message" (mouseenter)="onMouseDetect(true)" (mouseleave)="onMouseDetect(false)">
        <p class="author">
            {{thread.author.name }} @if(thread.isMoodAuthor){• <span class="badge bg-primary">{{ 'comment-card.author' | translate}}</span>}
        </p>
    <!--    HTML view -->
       <p class="body">
           <span [innerHTML]="$safeNavigationMigration(thread.message?.htmlFormat)"></span>
        </p>
        <!-- <p class="body">
            <quill-view [content]="thread.message?.objectModelFormat" format="object" theme="snow"></quill-view>
        </p> -->

        @for(linkPreview of thread.linkPreviews; track linkPreview){
        <div>
            <tm-link-preview [linkPreview]="linkPreview"></tm-link-preview>
        </div>
        }
    </div>
} @else {
<!-- edit mode -->
    <div class="media-body message-on-edition d-block">
        <tm-thread-input-area
                [thread]="thread"
                [threadAuthors]="threadAuthors"
                [updateMode]="true"
                (onThreadAdded)="onEditedThread($event)"
                (onCancelUpdates)="cancelUpdate()"></tm-thread-input-area>
    </div>
}

@if(!threadUpdateMode && !disableActions){
    @if(!(isHandset | async)){
        <div class="thread-actions" [ngClass]="{'active-actions': showThreadActions}" (mouseenter)="onMouseDetect(true)" (mouseleave)="onMouseDetect(false)">
            @if(thread.isEditable){
                <div (click)="editThread()">
                    <i class="far fa-edit" matTooltipPosition="right" matTooltip="{{'comment-card.options.edit' | translate }}"></i>
                </div>
                <div (click)="delete(thread)">
                    <i class="far fa-trash-alt" matTooltipPosition="right" matTooltip="{{'comment-card.options.delete' | translate }}"></i>
                </div>
            } @else {
                <div (click)="report(thread)">
                <i class="far fa-hexagon-exclamation" matTooltipPosition="right" matTooltip="{{'comment-card.options.report' | translate }}"></i>
                </div>
            }
        </div>
    } @else{
        <div class="thread-actions thread-actions-mobile">
            <button class="btn btn-secondary dropdown-toggle" type="button" [matMenuTriggerFor]="menu">
                <i class="fa-regular fa-ellipsis-vertical"></i>
            </button>
            <mat-menu #menu="matMenu">
                <ul class="p-0 m-0">
                    @if(thread.isEditable){
                        <li mat-menu-item class="dropdown-item" (click)="editThread()">
                            <i class="fa-regular fa-pen pe-1"></i> {{'comment-card.options.edit-mood' | translate }}
                        </li>
                        <li mat-menu-item class="dropdown-item" (click)="delete(thread)">
                            <i class="fa-regular fa-trash-alt pe-1"></i> {{'comment-card.options.delete-mood' | translate }}
                        </li>
                    } @else {
                        <li mat-menu-item class="dropdown-item" (click)="report(thread)">
                            <i class="fa-regular fa-hexagon-exclamation pe-1"></i> {{'comment-card.options.report' | translate }}
                        </li>
                    }
                </ul>
            </mat-menu>
        </div>
    }
}